import React from 'react';
import Select from "react-select";

const FormMultiSelect = ({item, index, global, setForm}) => {
    const multiSelectData = () => {
        let multiSelect = [];
        if(item.key === 'type_of_activity'){
            const activity = global.activities;
            for (let i = 0; i < activity.length; i++) {
                multiSelect.push({ label: activity[i].name, value: activity[i]?.url });
            }
        }
        if(item.key === 'service'){
            const activity = global.service;
            for (let i = 0; i < activity.length; i++) {
                multiSelect.push({ label: activity[i].name, value: activity[i]?.url });
            }
        }
        return multiSelect;
    };
    const getOption = (option,) => {
        setForm((prevForm) => {
            const updatedForm = [...prevForm];
            const updatedItem = { ...updatedForm[index] };

            updatedItem.active = false;
            updatedItem.value = option !== null ? option : [];
            updatedItem.valid = option !== null;

            updatedForm[index] = updatedItem;
            return updatedForm;
        });
    };
    return(

        <div key={index} className="company-dropdown">
            <Select
                value={item.value}
                options={multiSelectData() || []}
                isMulti
                onChange={option => getOption(option)}
            />
            {!item.valid && <div className="validation">{item.errorMessage}</div>}
        </div>
    )
};

export default FormMultiSelect;